import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';

@Component({
    selector: 'app-transfer-administrativas',
    templateUrl: './transfer-administrativas.component.html',
    styleUrls: ['./transfer-administrativas.component.scss'],
    standalone: false
})
export class TransferAdministrativasComponent implements OnInit {

  public UserList$: any;
  @Input() FormElement: UntypedFormControl;
  
  constructor(
    private selectionService: SelectionGenericService) { }

  ngOnInit(): void {
    this.selectionService.GetUsuarioList().subscribe(res => {
      if (res.code === 0) {
        this.UserList$ = res.result;
      }
    }, error => {
      console.error(error);
    });
  }

}
